import styled from 'styled-components';


const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 100%;
`

const Headline = styled.h2`
    font-family: "Sanomat Sans Text";
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 5px;
    color: #2E2A25;
`

const SubHeadline = styled.h3`
    font-family: "Sanomat Sans Text";
    font-size: 12px;
    color: #8a8a8d;
`

const Anchor = styled.a`
    font-family: "Sanomat Sans Text";
    font-size: 12px;
    margin-left: 4px;
    text-decoration: underline;
    color: #8a8a8d;
    cursor: pointer;
`

export {
    Headline,
    SubHeadline,
    Anchor,
    Container
};
